"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _analytics = _interopRequireDefault(require("../entel/analytics"));
var _constants = require("../../../utils/constants");
var _utils = require("../../../utils/utils");
var _services = require("../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class AnalyticsServiceCL extends _analytics.default {
  constructor(params) {
    super(params);
    this.numberOfPlans = 0;
  }
  startJourney() {
    console.log('Chile Journey started ....');
  }
  getPlanPrice(variant, costs) {
    var _configData$basicPlan, _variant$price, _variant$price$find, _variant$price2, _variant$price2$find, _variant$price3, _variant$price3$find, _variant$price4, _variant$price4$find;
    const isBasicPlan = _services.configData === null || _services.configData === void 0 ? void 0 : (_configData$basicPlan = _services.configData.basicPlanIds) === null || _configData$basicPlan === void 0 ? void 0 : _configData$basicPlan.some(text => text.includes(variant.variantId.split('-')[0]));
    return {
      productPrice: isBasicPlan ? variant === null || variant === void 0 ? void 0 : (_variant$price = variant.price) === null || _variant$price === void 0 ? void 0 : (_variant$price$find = _variant$price.find(_ref => {
        let {
          priceType
        } = _ref;
        return priceType === _constants.PRICE_TYPES.COMMERCE_ADDITIONAL_PLAN_PRICE;
      })) === null || _variant$price$find === void 0 ? void 0 : _variant$price$find.priceValue : variant === null || variant === void 0 ? void 0 : (_variant$price2 = variant.price) === null || _variant$price2 === void 0 ? void 0 : (_variant$price2$find = _variant$price2.find(_ref2 => {
        let {
          priceType
        } = _ref2;
        return priceType === _constants.PRICE_TYPES.COMMERCE_PRICE;
      })) === null || _variant$price2$find === void 0 ? void 0 : _variant$price2$find.priceValue,
      productSubprice: isBasicPlan ? variant === null || variant === void 0 ? void 0 : (_variant$price3 = variant.price) === null || _variant$price3 === void 0 ? void 0 : (_variant$price3$find = _variant$price3.find(_ref3 => {
        let {
          priceType
        } = _ref3;
        return priceType === _constants.PRICE_TYPES.LIST_ADDITIONAL_PLAN_PRICE;
      })) === null || _variant$price3$find === void 0 ? void 0 : _variant$price3$find.priceValue : variant === null || variant === void 0 ? void 0 : (_variant$price4 = variant.price) === null || _variant$price4 === void 0 ? void 0 : (_variant$price4$find = _variant$price4.find(_ref4 => {
        let {
          priceType
        } = _ref4;
        return priceType === _constants.PRICE_TYPES.RECURRING;
      })) === null || _variant$price4$find === void 0 ? void 0 : _variant$price4$find.priceValue
    };
  }
  showDiscount(flags) {
    return (flags === null || flags === void 0 ? void 0 : flags[_constants.FLAGS.IS_CUSTOMER]) || (flags === null || flags === void 0 ? void 0 : flags[_constants.FLAGS.BOTH_FLOW]);
  }
  composeTaggingEvents(_ref5) {
    var _currentQuestion$tagg, _currentQuestion$tagg2, _TAP_TEXT_MAP$current, _currentQuestion$choi;
    let {
      pageName,
      eventLabel,
      stepIndex,
      eventName,
      selectedOptionEvent,
      currentQuestion,
      currentProduct,
      costs,
      noOfPlans,
      title,
      flags
    } = _ref5;
    if (eventName === 'onToolAnswer') {
      this._composeQuestionAnswersMetadata({
        currentQuestion,
        selectedOptionEvent,
        stepIndex,
        flags
      });
      return {};
    }
    if (eventName === 'onToolView') {
      this._adjustQuestionAnswersMetadata({
        currentQuestion,
        selectedOptionEvent,
        stepIndex,
        flags
      });
      return {};
    }
    const taggingEventProps = {
      pageName,
      eventLabel,
      eventName,
      currentProduct,
      currentQuestion,
      stepIndex
    };
    let eventViewTag = this._composeTaggingViewEvent(taggingEventProps);
    let eventActionTag = this._composeTaggingActionEvent(taggingEventProps);
    if ((currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.if) === 'plan' || (currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg === void 0 ? void 0 : _currentQuestion$tagg.questionType) === 'plan') {
      eventActionTag['product_category'] = 'plan';
      eventActionTag['segment'] = 'po';
    }
    if (eventName === 'onTransversalActionEvents') {
      this.questionsAnswers = {};
      this.stepData = '';
      ['variant_1', 'variant_2', 'description', 'product_brand', 'product_price'].forEach(e => delete eventViewTag[e]);
    }
    if (currentQuestion !== null && currentQuestion !== void 0 && (_currentQuestion$tagg2 = currentQuestion.taggingMetadata) !== null && _currentQuestion$tagg2 !== void 0 && _currentQuestion$tagg2.keysToBeRemoved) {
      var _currentQuestion$tagg3;
      currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$tagg3 = currentQuestion.taggingMetadata) === null || _currentQuestion$tagg3 === void 0 ? void 0 : _currentQuestion$tagg3.keysToBeRemoved.forEach(e => {
        if (e === 'product_quantity') this.numberOfPlans = this.questionsAnswers['product_quantity'];
        delete eventActionTag[e];
        delete this.questionsAnswers[e];
      });
    }
    // remove unnecessary keys from result
    const eventsKeysToRemoveOnResult = ['onToolResult', 'onToolResultNext', 'onToolResultTabSwitch', 'onToolCompare', 'onAdditionalPlanUpdate'];
    if (eventsKeysToRemoveOnResult.includes(eventName)) {
      const keysToRemove = {};
      Object.keys(this.questionsAnswers).forEach(k => {
        if (k === 'visitor_type') return;
        keysToRemove[k] = undefined;
      });
      eventViewTag = {
        ...eventViewTag,
        ...keysToRemove
      };
      eventActionTag = {
        ...eventActionTag,
        ...keysToRemove
      };
    }
    const productTier = (currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.productType) === 'plan' ? (_TAP_TEXT_MAP$current = _constants.TAP_TEXT_MAP[currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier]) !== null && _TAP_TEXT_MAP$current !== void 0 ? _TAP_TEXT_MAP$current : currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier : currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.tier;
    const currentProductSpanishTier = (0, _utils.replaceSpanishCharacter)(_services.locale.localeString(`Recommendation.${productTier}`).toLowerCase());
    const productData = this._getProductData(currentProduct, costs, flags);
    let basketTagging = {};
    if (eventName === 'onToolCheckout') {
      ['variant_1', 'variant_2', 'description', 'variant_3'].forEach(e => delete eventActionTag[e]);
      basketTagging = {
        ...eventActionTag,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_subprice: productData === null || productData === void 0 ? void 0 : productData.product_subprice,
        product_price: productData === null || productData === void 0 ? void 0 : productData.product_price,
        event_label: (productData === null || productData === void 0 ? void 0 : productData.productType) === 'plan' ? _services.locale.localeString('Questionnaire.ButtonChoosePlan').toLowerCase() : _services.locale.localeString('Recommendation.ButtonNext').toLowerCase(),
        title: currentProductSpanishTier,
        product_brand: productData.product_brand,
        product_id: productData.product_id.split('-')[0],
        product_name: productData.product_name,
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        status: 'exito',
        ...(productData.product_category === 'plan' && {
          product_quantity: noOfPlans || this.questionsAnswers.product_quantity
        })
      };
      // saving basket tgging in loacl storage
      window.localStorage.setItem('basketTagging', JSON.stringify(basketTagging));
    }
    const isMixedJourney = currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$choi = currentQuestion.choices) === null || _currentQuestion$choi === void 0 ? void 0 : _currentQuestion$choi.some(choice => {
      var _choice$enable;
      return (_choice$enable = choice.enable) === null || _choice$enable === void 0 ? void 0 : _choice$enable.includes(_constants.FLAGS.BOTH_FLOW);
    });
    return {
      onToolStart: {
        ...eventViewTag,
        ...(!isMixedJourney && {
          event_name: 'tool_start'
        })
      },
      onToolNext: eventActionTag,
      onToolBack: eventActionTag,
      onToolRestart: {},
      onToolEnd: {
        ...eventViewTag,
        event_name: 'tool_end'
      },
      onToolResult: {
        ...eventViewTag,
        event_label: 'carga',
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        event_category: 'conversion',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        ...(productData.product_category === 'plan' && {
          product_quantity: this.questionsAnswers.product_quantity || this.numberOfPlans
        }),
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolResultNext: {
        ...eventActionTag,
        event_label: 'lo quiero',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        page_category: 'recomendador',
        form_step_name: `paso ${stepIndex} - conversion`,
        ...productData
      },
      onToolResultTabSwitch: {
        ...eventActionTag,
        event_label: currentProductSpanishTier,
        ...(productData.product_category !== 'plan' && {
          event_name: 'tool_success'
        }),
        event_category: 'tab',
        event: 'interaction',
        event_action: 'interaction',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        ...(productData.product_category === 'plan' && {
          product_quantity: this.questionsAnswers.product_quantity || this.numberOfPlans
        }),
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolCompare: {
        ...eventActionTag,
        event_label: productData.product_category === 'plan' ? 'comparar planes' : 'comparar equipos',
        status: 'exito',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        page_category: 'recomendador',
        form_step_name: `paso ${stepIndex} - conversion`,
        event_name: 'tool_success',
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onToolCheckout: {
        ...basketTagging,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        product_category: productData.product_category === 'plan' ? 'plan' : 'equipo'
      },
      onAdditionalPlanUpdate: {
        ...eventActionTag,
        event_label: `${noOfPlans} plan`,
        event_category: 'checkbox',
        event: 'interaction',
        event_action: 'interaction',
        title: currentProductSpanishTier,
        level_1: currentProductSpanishTier,
        form_step_name: `paso ${stepIndex} - conversion`,
        product_quantity: noOfPlans || this.questionsAnswers.product_quantity,
        segment: productData.product_category === 'plan' ? 'po' : 'tm-equ',
        ...productData
      },
      onTransversalView: {
        ...eventViewTag,
        event_category: 'error',
        event_label: 'carga',
        title: title ? (0, _utils.replaceSpanishCharacter)(title.toLowerCase()) : ''
      },
      onTransversalActionEvents: {
        ...eventViewTag,
        event: 'click_to_action',
        event_category: 'error',
        event_action: 'click_to_action',
        event_label: eventLabel ? (0, _utils.replaceSpanishCharacter)(eventLabel.toLowerCase()) : '',
        title: title ? (0, _utils.replaceSpanishCharacter)(title.toLowerCase()) : ''
      }
    };
  }
}
var _default = AnalyticsServiceCL;
exports.default = _default;